import { render, staticRenderFns } from "./SingleDocument.vue?vue&type=template&id=42b6d4a2&"
import script from "./SingleDocument.vue?vue&type=script&lang=js&"
export * from "./SingleDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports